import { Box, Typography } from '@mui/material'
import { useSchoolList } from '../../assets/api/useAdminApi'
import TableFilterTemplate from '../../shared/utils/TableFilterTemplate'


const SchoolList = () => {

    const { data: schoolList, isLoading } = useSchoolList()
    
    const schoolRow = schoolList?.data?.map((item, index) => ({
        sr_no: index + 1,
        ...item
    })) || []
    
    const schoolColumns = [
        {
            field: "sr_no",
            headerName: "Sr No",
            flex: 1,
            renderCell: (params) => <Typography variant="body2">{params.value}</Typography>

        },
        {
            field: "school_name",
            headerName: "School Name",
            flex: 1,
            renderCell: (params) => <Typography variant="body2">{params.value}</Typography>,
        },

        {
            field: "no_of_classes_students",
            headerName: "No of Classes & Students",
            flex: 1,
            renderCell: (params) => <Typography variant="body2">{params?.row?.role === "student" ? "" : params.value}</Typography>,
        },
        {
            field: "address",
            headerName: "Address",
            flex: 1,
            renderCell: (params) => <Typography variant="body2">{params.value}</Typography>,
        },
        {
            field: "latitude",
            headerName: "Latitude",
            flex: 1,
            renderCell: (params) => <Typography variant="body2">{params.value}</Typography>,
        },
        {
            field: "longitude",
            headerName: "Longitude",
            flex: 1,
            renderCell: (params) => <Typography variant="body2">{params.value}</Typography>,
        },
    ];

    return (
        <Box>
        <TableFilterTemplate
                title="School List"
                columns={schoolColumns}
                rowsData={schoolRow || []}
                isLoading={isLoading}

            />


        </Box>
    )
}

export default SchoolList